import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Toaster } from "sonner";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import PackagesPage from "./pages/PackagesPage";
import Dashboard from "./pages/Dashboard";
import ClientDashboard from "./pages/ClientDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import UmrahSelectionPage from "./pages/UmrahSelectionPage";
import UmrahMandiriPage from "./pages/UmrahMandiriPage";
import ProfilePage from "./pages/ProfilePage";
import OrderDetailPage from "./pages/OrderDetailPage";
import PackageDetailPage from "./pages/PackageDetailPage";
import LAPackagesPage from "./pages/LAPackagesPage";
import AffiliateDashboard from "./pages/AffiliateDashboard";
import AffiliatePage from "./pages/AffiliatePage";

function AppInner() {
  const location = useLocation();
  const hideFooter = /^\/packages\/.+/.test(location.pathname);
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/pilih-umrah" element={<UmrahSelectionPage />} />
              <Route path="/umrah-mandiri" element={<UmrahMandiriPage />} />
              <Route path="/la-packages" element={<LAPackagesPage />} />
              <Route path="/packages" element={<PackagesPage />} />
              <Route path="/packages/:id" element={<PackageDetailPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/dashboard" element={<ClientDashboard />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/order/:id" element={<OrderDetailPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/affiliate" element={<AffiliateDashboard />} />
              <Route path="/go/:code" element={<AffiliatePage />} />
            </Routes>
          </main>
          {!hideFooter && <Footer />}
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;
